export default __webpack_public_path__ + "static/media/Slide25.52669345.jpg";